/* global Search */

const getDate = () => {
    const dateObj = new Date(),
        month = String(dateObj.getMonth() + 1).padStart(2, "0"),
        day = String(dateObj.getDate()).padStart(2, "0"),
        year = dateObj.getFullYear();
    return `${year}${month}${day}`;
};

if (document.querySelector(".fbjs-search--webinar-archive")) {
    window.searchWebinarArchive = new Search.default({
        url: "https://wood-search01.squiz.co.uk/s/search.json",
        collections: ["wood-data"],
        additionalFBparams: {
            profile: "_default",
            "f.pageType|pageType": "event - webinar",
        },
        onFiltersUpdate: () => {},
        beforeSearch: () => {},
        results: {
            numRanks: 18,
        },
        activeFacetsOnStart: {
            "f.pageType|pageType": [],
            "f.keyMarketEnergy|keyMarketEnergy": [],
            "f.keyMarketEnvironment|keyMarketEnvironment": [],
        },
        sort: {
            type: "date",
        },
        pagination: {
            loadMore: true,
            arrows: false,
            arrowsOnEdgePages: false,
            dots: false,
            edgePages: false,
            pages: 0,
        },

        templates: {
            activeFacet: (name, param) => {
                const changeName = name
                    .replace(/_ampersand_/gi, "&")
                    .replace(/_comma_/gi, ",");
                return `
                  <span param="${param}" name="${name}">
                    ${changeName}
                  </span>
                `;
            },
            articleTemplate: (fields) => {
                const pageType = fields.metaData.pageType
                    ? fields.metaData.pageType.replace(/\w*\s-\s/gm, "")
                    : "";

                const marks = fields.metaData.marks;
                const date = fields.metaData.d;
                const cards = () => {
                    if (marks) {
                        let output = "";
                        const arrayOfMarks = marks.split(";");
                        arrayOfMarks.map((el) => {
                            output += `<div class="cards__flag-type">${el}</div>`;
                        });
                        return output;
                    }
                };

                const cardNew = () => {
                    // date = 2015-12-04
                    if (date) {
                        const storiesAssetCreated = date.replace(/-/g, ""),
                            globalDate = getDate();
                        if (
                            Number(globalDate) - Number(storiesAssetCreated) <=
                            15
                        ) {
                            return '<div class="cards__flag-new">new </div>';
                        }
                    }
                };
                // const aktDate = date.replace(/-/g, '');
                return `<div class="col-4 col-md-6 col-sm-12 col-lg-4">
                <div class="webinars-wrapper">
                    <article class="cards__card row no-gutters flex-column justify-content-between flex-wrap">
                        <div class="cards__flag-wrapper">
                        ${cards() || ""}
                        ${cardNew() || ""}
                    </div>
                        <!-- card image -->
                        <div class="cards__image-wrapper">
                            <div class="cards__image" style="
                                    background-image: url('${
                                        fields.metaData.image
                                    }');
                                "></div>
                        </div>
                        <div class="cards__content no-gutters flex-column justify-content-between">
                            <div>
                                <!-- card type - same as section header -->
                                <div class="type">${pageType}</div>
                                <!-- card title -->
                                <p class="title">
                                    ${fields.metaData.t}
                                </p>
                            </div>
                            <!-- link -->
                            <div class="cards__link">
                                <a class="primary-link" href="https://wood-search01.squiz.co.uk${
                                    fields.clickTrackingUrl
                                }"> Read more </a>
                            </div>
                        </div>
                    </article>
                </div>
                </div>`;
            },
            /**
             * @name informationTemplate
             * @param fields
             * @param resultsSummary
             * @param h
             * @returns {string}
             **/
            informationTemplate: () => {
                return "";
            },
            formTemplate: (search, query, inputId) => {
                query == "!nullsearch" ? (query = "") : null;
                return `
                    <form class="search__form" role="search" action="/search" method="get">
                        <label for="${inputId}" class="sr-only">Search site</label>
                        <input
                            id="${inputId}"
                            type="text"
                            class="search__form-input search-custom"
                            placeholder="Search..."
                            autocomplete="off"
                            role="searchbox"
                            aria-label="Search"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            maxlength="1000"
                            aria-haspopup="menu"
                            aria-expanded="false"
                            value="${query}">
                        <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                            <i class="search__submit-icon" aria-hidden="true"></i>
                            <span class="sr-only">Do search</span>
                        </button>
                        <div class="fb-search-wrapper"></div>
                    </form>
                `;
            },
            /**
             * @name paginationNumberTemplate
             * @param number
             * @param startRank
             * @returns {string}
             **/
            paginationNumberTemplate: () => {
                return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
            },
            /**
             * @name activePaginationNumberTemplate
             * @param number
             * @returns {string}
             **/
            activePaginationNumberTemplate: () => {
                return ""; //<li class="search__active-page hidden">${number}</li>
            },
            /**
             * @name paginationTemplate
             * @param pages
             * @returns {string}
             **/
            paginationTemplate: (pages) => {
                return `<div class="search__pagination">${pages}</div>`;
            },
            /**
             * @name loadMoreTemplate
             * @param fields
             * @returns {string}
             **/
            loadMoreTemplate: () => {
                return '<div class="landing-page__button-wrapper"><button id="search-loadmore" type="button" title="Load more results" class="btn btn--secondary">Load more</button></div>';
            },

            facetCheckbox: ({ categories, singleChoice }, activeFacets, h) => {
                //{name, label}, activeFacets
                // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                let list = "";
                list +=
                    '<li class="search__facet-item search__facet-item--all"></li>';

                categories[0].values.forEach((item) => {
                    if (item.label !== "other") {
                        list += `<li class="search__facet-item">
                                <label class="search__facet-label">
                                    <input
                                    class="search__facet-input"
                                    type="checkbox"
                                    ${item.checked}
                                    value="${item.data}"
                                    name="${item.label}"
                                    data-fparam="${h.queryStringParamName}"
                                    data-singlechoice="${singleChoice}"
                                    />
                                    <span class="search__facet-span">${item.label}</span>
                                </label>
                                </li>`;
                    }
                });

                return `<div class="checkbox-facet">
                        <ul class="search__facets">
                        ${list}
                        </ul>
                    </div>`;
            },
            /**
             * @name noResults
             * @param query
             * @param spell
             * @returns {string}
             **/
            noResults: () => {
                // let spellSuggestion = "";
                // if (spell.text) {
                //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                // }
                return `<div>We're sorry, we couldn't find anything matching .                
                </div>`;
            },
        },
    });

    window.searchWebinarArchive.init();
}
